import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { swSettings } from "app/common/services/swSettings";
import { trackEvent } from "app/components/React/Table/SWReactTableTrackEvent";
import { AppCellContainer } from "app/pages/app-intelligence/common-components/table-cells/styledComponents";
import { AppStoreID, AppStoreName } from "app/pages/app-intelligence/constants";
import { getHasPremiumPlusClaim } from "app/pages/app-intelligence/helpers";
import { AssetsService } from "app/services/AssetsService";
import CoreAppCell from "pro-features/components/core cells/src/CoreAppCell/CoreAppCell";

interface IAppCellProps {
    row: any;
    showStoreIcon?: boolean;
    onIntenalTrack?: (data) => void;
}

export const AppCell: FC<IAppCellProps> = ({ row, showStoreIcon = false, onIntenalTrack }) => {
    const { state } = useCurrentStateAndParams();

    const value = row.title;
    const store = row.tooltip?.appStore;
    const appInfo = row.tooltip;
    const appsAppleURL = `${swSettings.swsites.apps + "/app-analysis/overview/apple/"}`;
    const appsGoogleURL = `${swSettings.swsites.apps + "/app-analysis/overview/google/"}`;

    const getInternalLink = (row: any) =>
        store === AppStoreID.GOOGLE || store === AppStoreName.GOOGLE
            ? appsGoogleURL + row.appId
            : appsAppleURL + row.appId;

    const onTrackInternalLink = (row: any) => {
        onIntenalTrack && onIntenalTrack(row);
        trackEvent(null, "Internal Link", value, "click");
    };

    const externalLink =
        store === AppStoreID.GOOGLE || store === AppStoreName.GOOGLE
            ? `https://play.google.com/store/apps/details?id=${row.app}`
            : `https://itunes.apple.com/app/id${row.app}`;

    const getExternalLink = () => externalLink;

    const onTrackExternalLink = () => trackEvent(null, "External Link", value, "click");

    const isNewAppsAddon = getHasPremiumPlusClaim() && state.name.includes("app");

    return (
        <AppCellContainer>
            <CoreAppCell
                appInfo={appInfo}
                value={value}
                row={row}
                store={store}
                getAssetsUrl={AssetsService.assetUrl.bind(AssetsService)}
                getInternalLink={getInternalLink}
                onTrackInternalLink={onTrackInternalLink}
                getExternalLink={getExternalLink}
                onTrackExternalLink={onTrackExternalLink}
                showStoreIcon={showStoreIcon}
                hideMonthlyDownloads={isNewAppsAddon}
            />
        </AppCellContainer>
    );
};
